import { useMemo, useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { useAuth } from '@/contexts/AuthContext';
import { checkAchievements } from '@/lib/achievements';
import { Trophy, ChevronDown, ChevronUp } from 'lucide-react';
import { cn } from '@/lib/utils';

export function AchievementBadges() {
  const { data } = useAuth();
  const achievements = useMemo(() => checkAchievements(data), [data]);
  const [expanded, setExpanded] = useState(false);

  const earned = achievements.filter(a => a.earned);
  const locked = achievements.filter(a => !a.earned);
  const shown = expanded ? achievements : achievements.slice(0, 6);

  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary/10">
              <Trophy className="h-5 w-5 text-primary" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Achievements</p>
              <p className="font-display text-lg font-bold">
                {earned.length}<span className="text-xs font-normal text-muted-foreground"> / {achievements.length}</span>
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-2">
          {shown.map(a => (
            <div
              key={a.id}
              className={cn(
                'flex flex-col items-center rounded-lg p-2 text-center transition-all',
                a.earned
                  ? 'bg-primary/5'
                  : 'bg-muted/30 opacity-40 grayscale'
              )}
            >
              <span className="text-2xl mb-0.5">{a.icon}</span>
              <p className="text-[10px] font-medium leading-tight">{a.name}</p>
            </div>
          ))}
        </div>

        {achievements.length > 6 && (
          <button
            onClick={() => setExpanded(!expanded)}
            className="mt-2 flex w-full items-center justify-center gap-1 text-xs text-muted-foreground hover:text-foreground transition-colors"
          >
            {expanded ? <ChevronUp className="h-3 w-3" /> : <ChevronDown className="h-3 w-3" />}
            {expanded ? 'Show less' : `Show all ${achievements.length}`}
          </button>
        )}
      </CardContent>
    </Card>
  );
}
